module.exports = __webpack_public_path__ + "img/siteField.59ff1aaa.png";